import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/hooks/useAuthStore';

// Root ("/") is the public front door: everyone signed out sees the
// marketing site instead of being bounced to /login. Signed-in users go to
// their role-appropriate home instead of always landing on the admin
// Dashboard.
const RootRedirect = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const role = useAuthStore((state) => state.user?.role);

  if (!isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  if (role === 'TENANT') return <Navigate to="/tenants/portal" replace />;
  if (role === 'OWNER' || role === 'LANDLORD') return <Navigate to="/owner-portal" replace />;
  if (role === 'CLIENT') return <Navigate to="/tenants/application" replace />;
  if (role === 'AMBASSADOR') return <Navigate to="/ambassador" replace />;

  return <Navigate to="/dashboard" replace />;
};

export default RootRedirect;
